export const goToMailCommand = "R5yQJe";
export const goToCalendarCommand = "uX84cc";
export const goToHostedAppCommand = "kpQJYc";
export const goToDevToolsCommand = "wIiz0b";
export const goToEdgeTracingToolsCommand = "ogdjxb";
export const jumpFocus = "CL$_Nd";
export default {goToMailCommand,goToCalendarCommand,goToHostedAppCommand,goToDevToolsCommand,goToEdgeTracingToolsCommand,jumpFocus};